<div class="modal-header">
  <h4 class="modal-title" id="modal-title" translate>common_attention</h4>
</div>
<div class="modal-body">
  <p translate>common_unsaved_changes
  </p>
  <p>
    <span class="text-danger" translate>common_save_or_discard_changes</span>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="modal.close('Ok')" translate>common_ok</button>
</div>
